module.exports = __webpack_public_path__ + "static/media/cyrus-the-great.c74f46c6.webp";